import { render, staticRenderFns } from "./ProductCardPreview.vue?vue&type=template&id=50b60d57&scoped=true&"
import script from "./ProductCardPreview.vue?vue&type=script&lang=js&"
export * from "./ProductCardPreview.vue?vue&type=script&lang=js&"
import style0 from "./ProductCardPreview.vue?vue&type=style&index=0&id=50b60d57&lang=scss&scoped=true&"
import style1 from "./ProductCardPreview.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b60d57",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VColorPicker } from 'vuetify/lib/components/VColorPicker';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCard,VCardActions,VCardText,VCardTitle,VCol,VColorPicker,VDivider,VIcon,VImg,VMenu,VRow,VSelect})
